import {
    Box,
    Flex,
    Text,
    Accordion,
    Spinner
} from "@chakra-ui/react";

import {
    useEffect,
    useState,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import PageHeader from "../Dashboard/components/PageHeader";

import FAQSearch from "./components/FAQSearch";
import FAQSupportCard from "./components/FAQSupportCard";

import SupportTicketModal from "../Support/components/SupportTicketModal";
import FAQSkeleton from "./components/FAQSkeleton";

import {
    fetchFAQsAction,
} from "../../state/actions/faqActions";

const FAQ = () => {
    const dispatch =
        useDispatch();
    const [showSkeleton, setShowSkeleton] =
    useState(true);
    const [
        search,
        setSearch,
    ] = useState("");

    const [
        open,
        setOpen,
    ] = useState(false);

    const {
        faqs,
        loading,
    } = useSelector(
        (
            state
        ) =>
            state.faq
    );

    useEffect(() => {
        dispatch(
            fetchFAQsAction()
        );
    }, [
        dispatch,
    ]);
    useEffect(() => {
    dispatch(fetchFAQsAction());

    const timer = setTimeout(() => {
        setShowSkeleton(false);
    }, 3000);

    return () => clearTimeout(timer);
     }, [dispatch]);


    const driverPartnerFAQs =
        faqs.filter(
            (
                faq
            ) =>
                faq.category ===
                    "Driver Partner" &&
                !faq.archived
        );

    const filteredQuestions =
        driverPartnerFAQs.filter(
            (
                faq
            ) =>
                faq.question
                    ?.toLowerCase()
                    .includes(
                        search.toLowerCase()
                    ) ||
                faq.answer
                    ?.toLowerCase()
                    .includes(
                        search.toLowerCase()
                    )
        );

    if (showSkeleton) {
    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <FAQSkeleton />
                </Box>
            </Flex>
        </Flex>
    );
}

    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="Support & FAQ"
                        subtitle="Find answers to common questions about payouts, verification, recruits, safety and using the platform."
                    />

                    <FAQSearch
                        search={search}
                        setSearch={
                            setSearch
                        }
                    />

                    <Box
                        mt={8}
                        bg="white"
                        borderRadius="20px"
                        border="1px solid"
                        borderColor="gray.100"
                        p={{
                            base: 5,
                            md: 8,
                        }}
                    >
                        <Text
                            fontSize="xl"
                            fontWeight="700"
                            color="#071D54"
                            mb={2}
                        >
                            Frequently Asked Questions
                        </Text>

                        <Text
                            color="gray.500"
                            mb={6}
                        >
                            Browse answers to the
                            most common support
                            questions from Driver
                            Partners.
                        </Text>

                       {loading ? (
                            <Flex
                                justify="center"
                                align="center"
                                py={16}
                            >
                                <Spinner
                                    size="lg"
                                    color="#2453FF"
                                />
                            </Flex>
                        ) : (
                            <>
                                <Accordion.Root
                                    collapsible
                                >
                                    {filteredQuestions.map(
                                        (
                                            faq
                                        ) => (
                                            <Accordion.Item
                                                key={
                                                    faq.faq_id
                                                }
                                                value={
                                                    faq.faq_id
                                                }
                                            >
                                                <Accordion.ItemTrigger>
                                                    <Text
                                                        flex="1"
                                                        textAlign="left"
                                                        fontWeight="600"
                                                        color="#071D54"
                                                    >
                                                        {
                                                            faq.question
                                                        }
                                                    </Text>
                                                </Accordion.ItemTrigger>

                                                <Accordion.ItemContent>
                                                    <Text
                                                        color="gray.600"
                                                        lineHeight="1.8"
                                                        pb={4}
                                                    >
                                                        {
                                                            faq.answer
                                                        }
                                                    </Text>
                                                </Accordion.ItemContent>
                                            </Accordion.Item>
                                        )
                                    )}
                                </Accordion.Root>

                                {filteredQuestions.length ===
                                    0 && (
                                    <Box
                                        py={10}
                                        textAlign="center"
                                    >
                                        <Text
                                            color="gray.500"
                                        >
                                            No FAQs found.
                                        </Text>
                                    </Box>
                                )}
                            </>
                        )}
                    </Box>

                    <FAQSupportCard
                        onOpen={() =>
                            setOpen(
                                true
                            )
                        }
                    />
                </Box>
            </Flex>

            <SupportTicketModal
                isOpen={open}
                onClose={() =>
                    setOpen(
                        false
                    )
                }
            />
        </Flex>
    );
};

export default FAQ;